var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{attrs:{"icon":_vm.getIcon(_vm.icon, _vm.iconStyle),"icon-color":_vm.iconColor,"icon-size":_vm.iconSize,"tooltip":_vm.tooltipText,"loading":_vm.loading,"disabled":_vm.disabled,"x-small":""},on:{"click":_vm.copyText}})}
var staticRenderFns = []

export { render, staticRenderFns }